import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

const query = gql`
  query {
    allBeneficiaries {
      edges {
        node {
          name
          dbId
          description
        }
      }
    }
  }
`;

export const useAllBeneficiaries = () => {
  const { data: rawData, refetch, loading } = useQuery(query, { fetchPolicy: 'cache-first' });
  const data = (rawData?.allBeneficiaries?.edges.length) > 0 ? removeConnectionsMemoized(rawData?.allBeneficiaries) : [];
  return { data, refetch, loading };
};
